import { removeSkuFromState } from './removeSkuFromState';
export function setSkuQuantityInState(sku, quantity) {
    // if setting a SKU's quantity to 0, remove it from the cart state
    if (quantity <= 0) {
        return removeSkuFromState(sku);
    }
    return function (state) {
        return Object.assign(Object.assign({}, state), { items: state.items.map(item => {
                return item.sku === sku
                    ? Object.assign(Object.assign({}, item), { quantity }) : item;
            }) });
    };
}
